if ($('#js-homepage-target-school-staff-top-row').length > 0) {
    jQuery(document).ready(function () {
        var topRow = jQuery('#js-homepage-target-school-staff-top-row');
        var bottomRow = jQuery('#js-homepage-target-school-staff-bottom-row');
        var open = false;

        jQuery(window).scroll(function () {
            var pos = jQuery(window).scrollTop();
            // console.log(pos);
            if (pos > 1300 && pos < 3000) {
                if (!open) {
                    topRow.stop().animate({
                        left: '0'
                    }, 2000);
                    bottomRow.stop().animate({
                        right: '0'
                    }, 2000);

                    $.cssEase['bounce'] =
                        'cubic-bezier(0,1,1,1.1)';

                    window.setTimeout(function () {
                        $('.js-scrolling-headshot-1-line-1').transition({ y: -54 }, 500, 'bounce');
                    }, 3000);

                    window.setTimeout(function () {
                        $('.js-scrolling-headshot-1-line-2').transition({ y: -93 }, 500, 'bounce');
                        $('.js-scrolling-headshot-1-line-1').transition({ y: -93 }, 500, 'bounce');
                    }, 4000);

                    window.setTimeout(function () {
                        $('.js-scrolling-headshot-1-line-3').transition({ y: -132 }, 500, 'bounce');
                        $('.js-scrolling-headshot-1-line-2').transition({ y: -132 }, 500, 'bounce');
                        $('.js-scrolling-headshot-1-line-1').transition({ y: -132 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-1').transition({ y: -94 }, 500, 'bounce');
                    }, 5000);

                    window.setTimeout(function () {
                        $('.js-scrolling-headshot-1-line-4').transition({ y: -171 }, 500, 'bounce');
                        $('.js-scrolling-headshot-1-line-3').transition({ y: -171 }, 500, 'bounce');
                        $('.js-scrolling-headshot-1-line-2').transition({ y: -171 }, 500, 'bounce');
                        $('.js-scrolling-headshot-1-line-1').transition({ y: -171 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-2').transition({ y: -133 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-1').transition({ y: -133 }, 500, 'bounce');
                    }, 6000);

                    window.setTimeout(function () {
                        $('.js-scrolling-headshot-1-line-5').transition({ y: -210 }, 500, 'bounce');
                        $('.js-scrolling-headshot-1-line-4').transition({ y: -210 }, 500, 'bounce');
                        $('.js-scrolling-headshot-1-line-3').transition({ y: -210 }, 500, 'bounce');
                        $('.js-scrolling-headshot-1-line-2').transition({ y: -210 }, 500, 'bounce');
                        $('.js-scrolling-headshot-1-line-1').transition({ y: -210 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-3').transition({ y: -172 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-2').transition({ y: -172 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-1').transition({ y: -172 }, 500, 'bounce');
                    }, 7000);

                    window.setTimeout(function () {
                        $('.js-scrolling-headshot-2-line-4').transition({ y: -211 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-3').transition({ y: -211 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-2').transition({ y: -211 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-1').transition({ y: -211 }, 500, 'bounce');
                        $('.js-scrolling-headshot-1').css({
                            'padding-top': '10px',
                            'padding-bottom': '10px',
                            'margin-top': '0',
                            'margin-bottom': '0',
                            'background-color': '#ffffff',
                            '-webkit-mask-image': 'none',
                        });
                        $('.js-scrolling-headshot-line-container-1').transition({ y: -650 }, 900);
                        $('.js-scrolling-headshot-1-image').css('display', 'block').delay(200).transition({ y: -270 }, 900);
                    }, 8000);

                    window.setTimeout(function () {
                        $('.js-scrolling-headshot-2-line-5').transition({ y: -250 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-4').transition({ y: -250 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-3').transition({ y: -250 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-2').transition({ y: -250 }, 500, 'bounce');
                        $('.js-scrolling-headshot-2-line-1').transition({ y: -250 }, 500, 'bounce');
                    }, 9000);

                    window.setTimeout(function () {
                        $('.js-scrolling-headshot-2').css({
                            'padding-top': '10px',
                            'padding-bottom': '10px',
                            'margin-top': '0',
                            'margin-bottom': '0',
                            'background-color': '#ffffff',
                            '-webkit-mask-image': 'none',
                        });
                        $('.js-scrolling-headshot-line-container-2').transition({ y: -650 }, 900);
                        $('.js-scrolling-headshot-2-image').css('display', 'block').delay(200).transition({ y: -270 }, 900);
                    }, 10000);

                    open = true;
                }
            }
        });
    });
}
